export const headList = [
    { code: "name", title: "Name", mobileHide: false, isNumeric: false },
    { code: "picksetName", title: "Pickset Name", mobileHide: false, isNumeric: false },
    { code: "competitionTools", title: "Tools", mobileHide: false, isNumeric: false },
];